import React, { useEffect, useState } from 'react';
import { useGame } from '../context/GameContext';
import { CloudUpload } from 'lucide-react';

// v2.4 QoL — floating toast fires briefly whenever the run auto-saves (on map).
export default function AutoSaveToast() {
  const { lastAutoSaveAt } = useGame();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!lastAutoSaveAt) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 1600);
    return () => clearTimeout(t);
  }, [lastAutoSaveAt]);
  if (!visible) return null;
  return (
    <div
      className="fixed bottom-4 right-4 z-40 brutal-border-dim bg-[#0a0a0a] px-3 py-2 flex items-center gap-2 text-xs font-mono uppercase tracking-widest"
      style={{ borderColor: 'var(--neon)', color: 'var(--neon)', boxShadow: '3px 3px 0 var(--neon)' }}
      data-testid="autosave-toast"
    >
      <CloudUpload size={14}/> SAVED
    </div>
  );
}
